<template>
  <div class="m-x-3-lg m-x-2-md m-y-2-md">
    <span class="titulo-seccion">Principios del Manejo Ecológico Integral de Arvenses (MEIA)</span>
    <h1 class="titulo">Manuales</h1>
    <div class="contenedor-documentos">
      <DownloadFile
        file="descargables/alternativas/principios/manuales/CCOO-Aragon-DepartamentoMedioAmbiente-2016.pdf"
        type="appdivcation/pdf"
        format="PDF"
        name="Alternativas al uso del glifosato y otros herbicidas de síntesis química"
        downloadname="Alternativas_al_uso_del_glifosato_y_otros_herbicidad_de_sintesis_quimica.pdf"
        weight="7.3 MB"
        cover="descargables/alternativas/principios/manuales/img_PMEIA_man_001.jpg" />
    </div>
  </div>
</template>

<script>
import DownloadFile from '@/components/DownloadFile.vue'

export default {
  name: "PrincipiosArvensesManuales",
  components: {
    DownloadFile
  },
  mounted() {
    this.$store.commit('setTemaAlternativa', 'Principios del Manejo Ecológico Integral de Arvenses (MEIA)');
    this.$store.commit('setSubtemaAlternativa', 'Manuales');
  },
};
</script>
